module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_0@3x.221ab5fa.png";